import { FullContainer } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { JOBS_PAGE, USERS_PAGE } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { pageState } from '../../storage/app';
import Map from '../shared/map/Map';

function PageLayout() {
  const { css } = useStyles();
  const page = useRecoilValue(pageState);
  const hasMap = page === USERS_PAGE.id || page === JOBS_PAGE.id;

  return (
    <FullContainer
      flexible
      classNames={css({
        position: 'relative',
        overflow: 'hidden',
      })}
    >
      {hasMap && <Map />}
      <Outlet />
    </FullContainer>
  );
}

export default memo(PageLayout);
